import { TApplicationState } from '../../types/redux';

export function getGeoSubdomain(state: TApplicationState): string {
  return state.geoSubdomain;
}
